import { WorkloadResourceLimitFormModel } from './_types';

export const formatCpuResourceLimit = (
  limit: WorkloadResourceLimitFormModel
): string => {
  if (limit.type === 'NO_LIMIT') {
    return 'No limits';
  }
  if (limit.type === 'KEEP_LIMITS') {
    return 'Keep limits';
  }
  if (limit.type === 'MAINTAIN_RATIO') {
    return 'Keep ratio';
  }
  if (limit.type === 'SEMI_AUTOMATIC') {
    return `Semi-automatic ${limit.semiAutoMultiplier ?? ''}`;
  }
  return `${limit.multiplier ?? ''}`;
};

export const formatMemoryResourceLimit = (
  limit: WorkloadResourceLimitFormModel
): string => {
  if (limit.type === 'NO_LIMIT') {
    return 'No limits';
  }
  if (limit.type === 'KEEP_LIMITS') {
    return 'Keep limits';
  }
  if (limit.type === 'MAINTAIN_RATIO') {
    return 'Keep ratio';
  }
  if (limit.type === 'AUTO') {
    return 'Automatic';
  }
  return `${limit.multiplier ?? ''}`;
};
